import { RowConfig } from '@/shared/types/table';

export const toggleRowSelection = (
  selectedIds: (string | number)[],
  rowId: string | number,
): (string | number)[] => {
  const isSelected = selectedIds.includes(rowId);
  return isSelected ? selectedIds.filter((id) => id !== rowId) : [...selectedIds, rowId];
};

export const selectAllRows = <T>(
  rows: RowConfig<T>[],
  currentSelection: (string | number)[],
): (string | number)[] => {
  const allIds = rows.map((row) => row.id);
  const allSelected = allIds.every((id) => currentSelection.includes(id));

  return allSelected ? [] : allIds;
};

export const selectRange = (
  selectedIds: (string | number)[],
  allIds: (string | number)[],
  fromId: string | number,
  toId: string | number,
): (string | number)[] => {
  const fromIndex = allIds.indexOf(fromId);
  const toIndex = allIds.indexOf(toId);

  if (fromIndex === -1 || toIndex === -1) return selectedIds;

  const start = Math.min(fromIndex, toIndex);
  const end = Math.max(fromIndex, toIndex);

  const rangeIds = allIds.slice(start, end + 1);
  const newSelection = new Set([...selectedIds, ...rangeIds]);

  return Array.from(newSelection);
};

export const isAllSelected = <T>(
  rows: RowConfig<T>[],
  selectedIds: (string | number)[],
): boolean => {
  if (rows.length === 0) return false;
  return rows.every((row) => selectedIds.includes(row.id));
};

export const isSomeSelected = <T>(
  rows: RowConfig<T>[],
  selectedIds: (string | number)[],
): boolean => {
  if (selectedIds.length === 0) return false;
  return rows.some((row) => selectedIds.includes(row.id)) && !isAllSelected(rows, selectedIds);
};
